var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-select-none tw-flex-row tw-flex-wrap"},[_c('p',{staticClass:"tw-mr-[.2em] tw-text-xs",attrs:{"data-test-id":"reactivity-values"}},[_vm._v("\n    "+_vm._s(_vm.reactivity.join(', '))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }